<div class="overlay" [ngClass]="{ 'show': isLoading }">
    <div class="loader"></div>
</div>